<res-info-panel *ngIf="showOwnInfoPanel" [i18nKey]="hisDynamicContent" [target]="target"></res-info-panel>
<ng-content select="[customStaticContent]"></ng-content>
<div [ngClass]="{layoutBlock: !fullWidth}">
    <div [ngClass]="{columnTwoThird: !fullWidth}">
		<ng-container *ngFor="let dynamicFieldSetContainer of dynamicTabChildCount">
		    <ng-template #dynamicFieldSetContainer></ng-template>
		</ng-container>
	</div>
</div>
